import { getWindow } from "../../../@floating-ui/utils/dist/floating-ui.utils.dom.js";
function dispatchClickWithModifiers(target, sourceEvent, {
  detail = 0
} = {}) {
  target.dispatchEvent(new (getWindow(target)).PointerEvent("click", {
    bubbles: true,
    cancelable: true,
    composed: true,
    detail,
    shiftKey: sourceEvent.shiftKey,
    ctrlKey: sourceEvent.ctrlKey,
    altKey: sourceEvent.altKey,
    metaKey: sourceEvent.metaKey
  }));
}
export {
  dispatchClickWithModifiers
};
//# sourceMappingURL=dispatchClickWithModifiers.js.map
